import { render, staticRenderFns } from "./goods-selectsearch-bar.vue?vue&type=template&id=3fee7164&scoped=true"
import script from "./goods-selectsearch-bar.vue?vue&type=script&lang=js"
export * from "./goods-selectsearch-bar.vue?vue&type=script&lang=js"
import style0 from "./goods-selectsearch-bar.vue?vue&type=style&index=0&id=3fee7164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee7164",
  null
  
)

export default component.exports